/**
 * Application principale - Calculatrice de potentiel énergétique AEP
 * 
 * Application React autonome pour l'intégration dans un site Joomla.
 * Calcule le potentiel énergétique d'un réseau d'Alimentation en Eau Potable.
 */

import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import EnergyCalculator from "./components/EnergyCalculator";

// Options de style pour les toasts (extrait pour éviter les objets inline)
const TOAST_STYLE = {
  fontFamily: 'IBM Plex Sans, sans-serif',
};

const TOAST_OPTIONS = {
  style: TOAST_STYLE,
};

function App() {
  return (
    <div className="App">
      {/* Notifications toast */}
      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={TOAST_OPTIONS}
      />
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EnergyCalculator />} />
          <Route path="*" element={<EnergyCalculator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
